"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ElmerWorkerCore = (function () {
    function ElmerWorkerCore() {
    }
    ElmerWorkerCore.prototype.sendMsg = function (msg) {
        self["postMessage"](msg);
    };
    return ElmerWorkerCore;
}());
exports.ElmerWorkerCore = ElmerWorkerCore;
